import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { CommonDataService } from './common-data.service';
import { httpExtensionService } from './httpextension.service';
import { ResponseContentType } from '@angular/http';
@Injectable()
export class MembersService {

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService, private commonDataService: CommonDataService) { }

    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }

    getMembers(body) {
        //let body = userData;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.apiURI + this.config.membersList, body,{
            headers: headers
        })
    }

    createMember(memberData) {
        let body = this.commonDataService.urlDataDecoded(memberData);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.createMember, body, {
            headers: headers
        })
    }

    changeMemberStatus(memberId, blockData) {
        let userData = {
            id: memberId,
            blocked: blockData
        }
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.changeMemberStatus(memberId), body, {
            headers: headers
        })
    }

    getMember(memberId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.getMember(memberId), {
            headers: headers
        })
    }

    updateMember(memberId, userData) {
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.updateMember(memberId), body, {
            headers: headers
        })
    }

    cancelSubscription(subscriptionId) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.put(this.config.cancelSubscription(subscriptionId), '',{
            headers: headers
        })
    }

    getMemberAddresses(memberId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.get(this.config.apiURI + this.config.getMemberAddresses(memberId), {
            headers: headers
        })
    }

    listMemberProductCards(memberId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.listMemberProductCards(memberId), {
            headers: headers
        })
    }

    addMemberAddress(memberId, memberData) {
        let body = this.commonDataService.urlDataDecoded(memberData);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.addMemberAddress(memberId), body, {
            headers: headers
        })
    }

    changeMemberPassword(memberId, password, rePassword) {
        let userData = {
            id: memberId,
            newPassword: password,
            rePassword: rePassword
        }
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.changeMemberPassword, body, {
            headers: headers
        })
    }

    deleteMemberAddress(memberId, addressId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.delete(this.config.apiURI + this.config.deleteMemberAddress(memberId, addressId), {
            headers: headers
        })
    }

    editMemberAddress(memberId, addressId, userData) {
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.editMemberAddress(memberId, addressId), body, {
            headers: headers
        })
    }

    getMemberOrders(orderData) {
        let body = orderData;
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.apiURI + this.config.getMemberOrders, body, {
            headers: headers
        })
    }

    setNotesToMember(memberId, notes) {
        let data = { notes: notes }
        let body = this.commonDataService.urlDataDecoded(data);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.setNotesToMember(memberId), body, {
            headers: headers
        })
    }

    addProductCardToMember(memberId, data) {
        let body = this.commonDataService.urlDataDecoded(data);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.addProductCardToMember(memberId), body, {
            headers: headers
        })
    }

    exportMembers(userData){
        let body = userData;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.exportMembers, body, {
            headers: headers,
            responseType: ResponseContentType.ArrayBuffer
        }).map(res => new Blob([res._body],{ type: 'application/vnd.ms-excel' }));
    }

    exportMembersEmails(userData){
        let body = userData;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.exportMembersEmails, body, {
            headers: headers,
            responseType: ResponseContentType.ArrayBuffer
        }).map(res => new Blob([res._body],{ type: 'application/vnd.ms-excel' }));
    }

    private handleError(error: any) {
        return Observable.throw(error.json());
    }


    mMemberOrdersGridState: any;
    mMemberOrdersGridStateTime: any;
    mMembersGridState: any;
    mMembersGridStateTime: any;

    getProdCardsGridState() {
        if(this.mMemberOrdersGridState && this.mMemberOrdersGridStateTime && (this.mMemberOrdersGridStateTime > Date.now())) {
            return this.mMemberOrdersGridState;
        } else {
            this.mMemberOrdersGridState = null;
            return null;
        }
    }

    setProdCardsGridState(data){
        this.mMemberOrdersGridState = data;
        this.mMemberOrdersGridStateTime = Date.now() + this.config.timeToKeepStates;
    }

    getMembersGridState() {
        if(this.mMembersGridState && this.mMembersGridStateTime && (this.mMembersGridStateTime > Date.now())) {
            return this.mMembersGridState;
        } else {
            this.mMembersGridState = null;
            return null;
        }
    }

    setMembersGridState(data){
        this.mMembersGridState = data;
        this.mMembersGridStateTime = Date.now() + this.config.timeToKeepStates;
    }

    toggleMembershipStatus(userId, membershipId) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.toggleMembershipStatus(userId, membershipId), {}, {
            headers: headers
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/members.service.ts